import React from "react";
import { Outlet } from "react-router-dom";
import { Layout, Drawer, Button, message } from "antd";
import { useSelector } from "react-redux";
import "./style.css";
// import logo from "../../../config/img/logo.png";
// component
import LayoutMenu from "./layout_menu";
import LayoutFooter from "./layout_footer";

// redux
import { collapseSelector } from "../../../store/bailiff/nav/nav.selector";
import { useDispatch } from "react-redux";
import { toggleCollapse } from "store/bailiff/nav/nav.action";
import { LogoutOutlined } from "@ant-design/icons";
import { logOut } from "store/user/auth/user_auth.action";
import { setDraftDialogPlay } from "store/bailiff/task/dialog/draft_dialog.action";
import { useFlow, FLOWS } from "hook/draft/dialog/flow/useFlow";

const LayoutRoot = () => {
  // -------------------------- VAR --------------------------
  const { flow } = useFlow();
  const hasTask = flow === FLOWS.HAS_TASK;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const collapsed = useSelector(collapseSelector);
  // -------------------------- EFFECT --------------------------

  // -------------------------- FUNCTION --------------------------
  const onClose = () => {
    dispatch(toggleCollapse());
  };

  const handleLogout = () => {
    if (hasTask) {
      message.info("Vui lòng hoàn thành hoặc rời nhiệm vụ trước khi đăng xuất");
      return;
    }
    dispatch(setDraftDialogPlay(false));
    dispatch(logOut());
    onClose();
  };

  // -------------------------- RENDER --------------------------
  const DrawerSection = () => {
    return (
      <Drawer
        closable={false}
        rootClassName="drawer-layout"
        styles={{ padding: 5, position: "relative" }}
        onClose={onClose}
        placement="left"
        width={260}
        open={collapsed}
      >
        <div className="logo">
          <div
            style={{
              minHeight: 60,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              fontSize: 20,
            }}
          >
            Dịch Vụ Chuyển Âm
          </div>
        </div>
        <LayoutMenu />
        <div
          style={{
            position: "absolute",
            bottom: 10,
            left: 0,
            right: 0,
            minHeight: 50,
            textAlign: "center",
          }}
        >
          <Button onClick={handleLogout} icon={<LogoutOutlined />}>
            Đăng Xuất
          </Button>
        </div>
      </Drawer>
    );
  };
  // -------------------------- MAIN --------------------------

  return (
    <Layout>
      <DrawerSection />
      <Layout>
        <Outlet />
        <LayoutFooter />
      </Layout>
    </Layout>
  );
};

export default LayoutRoot;
